<ng-multiselect-dropdown #multiselect
[placeholder]="'--Select--'"
[settings]="fieldSetting"
[data]="data"
[(ngModel)]="activeUserList"
class="singleselect"
(onSelect)="setEvent($event)"
(onDeSelect)="removeEvent($event)"
[title]="title">
</ng-multiselect-dropdown>
